/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import type { ExportedPasswordCredential } from './ExportedPasswordCredential';
import {
    instanceOfExportedPasswordCredential,
    ExportedPasswordCredentialFromJSON,
    ExportedPasswordCredentialFromJSONTyped,
    ExportedPasswordCredentialToJSON,
} from './ExportedPasswordCredential';
import type { ExportedPublicKeyCredential } from './ExportedPublicKeyCredential';
import {
    instanceOfExportedPublicKeyCredential,
    ExportedPublicKeyCredentialFromJSON,
    ExportedPublicKeyCredentialFromJSONTyped,
    ExportedPublicKeyCredentialToJSON,
} from './ExportedPublicKeyCredential';
import type { ExportedTOTPCredential } from './ExportedTOTPCredential';
import {
    instanceOfExportedTOTPCredential,
    ExportedTOTPCredentialFromJSON,
    ExportedTOTPCredentialFromJSONTyped,
    ExportedTOTPCredentialToJSON,
} from './ExportedTOTPCredential';

/**
 * @type ExportedCredential
 * 
 * @export
 */
export type ExportedCredential = { type: 'password' } & ExportedPasswordCredential | { type: 'public-key' } & ExportedPublicKeyCredential | { type: 'totp' } & ExportedTOTPCredential;

export function ExportedCredentialFromJSON(json: any): ExportedCredential {
    return ExportedCredentialFromJSONTyped(json, false);
}

export function ExportedCredentialFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportedCredential {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'password':
            return Object.assign({}, ExportedPasswordCredentialFromJSONTyped(json, true), { type: 'password' } as const);
        case 'public-key':
            return Object.assign({}, ExportedPublicKeyCredentialFromJSONTyped(json, true), { type: 'public-key' } as const);
        case 'totp':
            return Object.assign({}, ExportedTOTPCredentialFromJSONTyped(json, true), { type: 'totp' } as const);
        default:
            return json;
    }
}

export function ExportedCredentialToJSON(json: any): any {
    return ExportedCredentialToJSONTyped(json, false);
}

export function ExportedCredentialToJSONTyped(value?: ExportedCredential | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'password':
            return Object.assign({}, ExportedPasswordCredentialToJSON(value), { type: 'password' } as const);
        case 'public-key':
            return Object.assign({}, ExportedPublicKeyCredentialToJSON(value), { type: 'public-key' } as const);
        case 'totp':
            return Object.assign({}, ExportedTOTPCredentialToJSON(value), { type: 'totp' } as const);
        default:
            return value;
    }
}

